import { render, staticRenderFns } from "./EditRecommededCourse.html?vue&type=template&id=1320774c&scoped=true&"
import script from "./EditRecommendedCourse.vue?vue&type=script&lang=js&"
export * from "./EditRecommendedCourse.vue?vue&type=script&lang=js&"
import style0 from "./EditRecommendedCourses.scss?vue&type=style&index=0&id=1320774c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1320774c",
  null
  
)

export default component.exports